import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchInvestigatorModule } from "./learningAPI";

export interface InvestigatorModState {
  investigatormodule: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: InvestigatorModState = {
    investigatormodule: [],
  status: "idle",
};

export const GetInvestigatorModule = createAsyncThunk(
  "Investigator/fetchInvestigator",
  async (data:any) => {
    const response = await fetchInvestigatorModule(data);
    return response;
  }
);

export const InvestigatorModuleSlice = createSlice({
  name: "Investigator",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetInvestigatorModule.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetInvestigatorModule.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetInvestigatorModule.fulfilled, (state, action) => {
        state.status = "idle";
        state.investigatormodule = action.payload.material;
        //console.log(action.payload.material,"action.payload.material;")
        //state.Investigatormodule = state.Investigatormodule.concat(action.payload.material);
      });
  },
});

export const {} = InvestigatorModuleSlice.actions;

export const selectInvestigatorModule = (state: RootState) => {
  return state.InvestigatorModule.investigatormodule;
};

export default InvestigatorModuleSlice.reducer;
